module.exports = __webpack_public_path__ + "img/logo-element1.4caec261.png";